import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslocoService } from '@ngneat/transloco';
import { Subject } from 'rxjs';
import { DialogService } from 'src/app/core/services/dialog/dialog.service';
import { EventDataTagTypeEnum } from 'src/app/core/services/event-data/event-data.service';
import { ILoanApplication } from 'src/app/core/services/loan-application/loan-application.model';
import { LoanApplicationService } from 'src/app/core/services/loan-application/loan-application.service';
import { EventLogApiService } from 'src/app/core/services/mobile-api';
import { TagDataService } from 'src/app/core/services/tag-data/tag-data.service';
import { QuestionTypeEnum } from '../co-app-common-questions/co-app-common-questions.component';

@Component({
	selector: 'op-co-app-landing',
	templateUrl: './co-app-landing.component.html',
	styleUrls: ['./co-app-landing.component.scss']
})
export class CoAppLandingComponent implements OnInit, OnDestroy {
	private buffer = 0;
	private destroy$ = new Subject<void>();
	needStrongCredit: boolean;
	isFooterVisible = false;
	loanApp: ILoanApplication;
	coAppDetails;
	questionTypeEnum = QuestionTypeEnum;

	constructor(
		private eventLogService: EventLogApiService,
		private tagDataService: TagDataService,
		protected loanAppService: LoanApplicationService,
		private dialogService: DialogService,
		protected translocoService: TranslocoService,
		private route: ActivatedRoute
	) {}

	ngOnDestroy(): void {
		this.destroy$.next();
		this.destroy$.complete();
	}

	ngOnInit(): void {
		this.coAppDetails = this.route.snapshot.data['coAppDetails'];
		this.tagDataService.link(
			{},
			{
				event_category: 'co_applicant_landing_screen',
				tealium_event: `Co applicant landing screen`
			}
		);
	}

	@HostListener('window:scroll', [])
	onScroll() {
		const footerEl = document.querySelector('op-footer');
		if (!footerEl) return;
		const rect = footerEl.getBoundingClientRect();
		const windowHeight = window.innerHeight;
		const top = rect.top - this.buffer;
		this.isFooterVisible = top <= windowHeight;
		this.buffer = this.isFooterVisible ? 200 : 0;
	}

	callUs(): void {
		const tagEvent = {
			event_category: 'co_applicant_call_us',
			event_action: 'Button Click',
			event_label: 'Call Now',
			event_type: EventDataTagTypeEnum.coAppOfferScreenOnlineCallNow
		};
		this.tagDataService.link({}, tagEvent);
		this.dialogService
			.openContactUsDialogWithPhone(this.translocoService.translate('CALL_US.coAppHelpLine'))
			.subscribe();
		const event = {
			applicantId: this.loanAppService.getCurrentApplicant()?.id,
			eventType: EventDataTagTypeEnum.coAppOfferScreenOnlineCallNow,
			loanApplicationId: this.coAppDetails.loanApplicationId
		};
		this.eventLogService.logLoanAppEvent(event).subscribe();
	}
}
